import './App.css';
import { HomePage } from './view/pages';

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
